import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22128 22238"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528319929168">
        <path
          d="M19076 20995H3054c-115 0-208-93-208-208v-2011c0-116 93-208 208-208s208 92 208 208v1803h15606v-1803c0-116 93-208 208-208 116 0 208 92 208 208v2011c0 115-92 208-208 208z"
          className="fil0"
        />
        <path
          d="M20390 20995H1740c-115 0-208-93-208-208V1452c0-115 93-208 208-208h18650c115 0 208 93 208 208v19335c0 115-93 208-208 208zm-18444-416h18236V1660H1946v18919z"
          className="fil0"
        />
        <path
          d="M21298 1660H830C371 1660 0 1289 0 830 0 374 371 0 830 0h20468c459 0 830 373 830 830 0 459-371 830-830 830zM832 416c-228 0-413 186-413 414s185 414 413 414h20468c228 0 414-186 414-414s-186-414-414-414H832zM21298 22238H830c-459 0-830-371-830-830s371-829 830-829h20468c459 0 830 370 830 829s-371 830-830 830zM832 20995c-228 0-413 185-413 413 0 229 185 414 413 414h20468c228 0 414-185 414-414 0-228-186-413-414-413H832z"
          className="fil0"
        />
        <path
          d="M4744 18026H3610c-421 0-764-344-764-765V1452c0-115 93-208 208-208h2247c115 0 208 93 208 208v15809c0 421-344 765-765 765zM3262 1660v15601c0 193 156 349 348 349h1134c193 0 349-156 349-349V1660H3262zM9235 18026H8101c-421 0-764-344-764-765V1452c0-115 92-208 208-208h2246c116 0 208 93 208 208v15809c3 421-341 765-764 765zM7753 1660v15601c0 193 158 349 348 349h1134c193 0 348-156 348-349V1660H7753z"
          className="fil0"
        />
        <path
          d="M6988 17429H5855c-422 0-765-343-765-765V1454c0-115 93-208 208-208h2247c115 0 208 93 208 208v15210c0 422-341 765-765 765zM5509 1660v15002c0 193 155 348 348 348h1134c193 0 348-155 348-348V1660H5509zM18520 18026h-1134c-421 0-765-344-765-765V1452c0-115 93-208 208-208h2247c116 0 208 93 208 208v15809c0 421-343 765-764 765zM17038 1660v15601c0 193 155 349 348 349h1134c193 0 348-156 348-349V1660h-1830zM14026 18026h-1133c-421 0-765-344-765-765V1452c0-115 93-208 208-208h2247c115 0 208 93 208 208v15809c0 421-343 765-765 765zM12544 1660v15601c0 193 156 349 349 349h1133c193 0 349-156 349-349V1660h-1831z"
          className="fil0"
        />
        <path
          d="M16273 17429h-1133c-422 0-765-343-765-765V1454c0-115 93-208 208-208h2246c116 0 209 93 209 208v15210c0 422-344 765-765 765zM14791 1660v15002c0 193 155 348 349 348h1133c193 0 348-155 348-348V1660h-1830z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
